(() => {
  const select = document.querySelector('[data-josephine-language]');
  if (!select) return;
  const key = 'josephine-language-choice';
  const current = document.documentElement.lang.split('-')[0];
  const available = [...select.options].map(option => option.value);
  let preference = null;
  try { preference = localStorage.getItem(key); } catch (_) {}
  select.addEventListener('change', () => {
    try { localStorage.setItem(key, select.value); } catch (_) {}
    select.form.requestSubmit();
  });
  if (current === 'hr') {
    const localizeLinks = () => document.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !/^\/(?:pages|collections|products|search|cart)(?:\/|$)/.test(url.pathname)) return;
      url.pathname = '/hr' + url.pathname;
      link.href = url.href;
    });
    localizeLinks();
    new MutationObserver(localizeLinks).observe(document.body, { childList: true, subtree: true });
    return;
  }
  const browserLanguage = (navigator.languages?.[0] || navigator.language || '').split('-')[0];
  if (!preference && current === 'sl' && browserLanguage === 'hr' && available.includes('hr')) {
    try {
      if (sessionStorage.getItem('josephine-auto-hr')) return;
      sessionStorage.setItem('josephine-auto-hr', '1');
    } catch (_) {}
    select.value = 'hr';
    select.form.requestSubmit();
  }
})();
